﻿import React, { useState } from 'react';
import { Document } from '../models/document';
import { DocumentType } from '../models/enums';
import { CrudFunctions } from '../utilities/crud-functions';
import GlobalDialog from './Modal/GlobalDialog';
import { ModalMetadata } from '../models/modal-metadata';
import { ModalMessageType } from '../models/enums';

import { Button } from 'devextreme-react/button';

export interface Props {
    documentId?: string;
    parentId?: string;
    documentName?: string;
    label?: string;
    readOnly?: boolean;
    onDocumentLoaded?: (e: Document) => void;
}

export default function SingleDocumentLoader(props: Props) {
    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    return (
        <div className="pw-margin-bottom-05">
            <div className="lq-header-2">{props.label}</div>
            <div className="pw-file-input-container">
                <input type="file" className="pw-file-input"
                    onChange={onFileLoaderChange}></input>

                {props.documentName &&
                    <div className="pw-flex-100">
                        <div className="pw-file-input-label">
                            {props.documentName}</div>
                        <Button className="pw-margin-left-1" icon="download" disabled={props.readOnly}
                            onClick={downloadDocument} />
                        <div className="pw-right-align-content">
                            <Button id="documentDelete" icon="trash" onClick={onDeleteDocument} />
                        </div>
                    </div>
                }
            </div>

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} onClose={clearGlobalDialog} />
            }

        </div>
    );

    async function onFileLoaderChange(e: any) {
        if (e.target && e.target.files) {
            let files = e.target.files;

            if (files && files.length > 0) {
                let file = files[0];

                let doc: Document = {
                    name: file.name,
                    kbSize: file.size,
                    mimeTypeString: file.type
                };

                var reader = new FileReader();

                reader.onload = (event: any) => readFile(doc, event)
                    .then((doc) => {
                        onDocumentLoaded(doc);
                    });

                reader.readAsBinaryString(file);
            }
        }
    }

    async function readFile(doc: Document, event: any): Promise<any> {
        if (event && event.target && event.target.result) {
            let binaryString = event.target.result;
            let documentData = btoa(binaryString);

            doc.base64Blob = documentData;
            return doc;
        }
    }

    function onDeleteDocument(e: any) {
        console.log("onDeleteDocument");
        console.log(e);

        if (e.element && e.element.id)
            deleteDocument(props.documentId);
    }

    async function downloadDocument() {
        console.log("downloadDocument:");
        console.log(props.documentId);

        if (props.documentId) {
            await CrudFunctions.getData(`media/document/${props.documentId}`)
                .then((blob: any) => {
                    let a = document.createElement("a") as HTMLAnchorElement;

                    document.body.appendChild(a);
                    a.style.display = "none";

                    var url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = props.documentName ? props.documentName : "file";
                    a.click();
                    window.URL.revokeObjectURL(url);
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Downloading Document");
                });
        }
    }

    async function onDocumentLoaded(spectralCoefficientsDocument: Document) {
        spectralCoefficientsDocument.parentId = props.parentId;

        // REWORK
        //spectralCoefficientsDocument.documentType = DocumentType.SpectralCoefficient;

        if (props.onDocumentLoaded)
            props.onDocumentLoaded(spectralCoefficientsDocument);
    }

    async function deleteDocument(documentId: string) {
        return CrudFunctions.deleteData(`media/document/${documentId}`);
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }

}
